import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { handleStopPropagation } from 'consts';
import { load, LOAD } from 'model/fspConfigValues';
import { selector as isBusySelector } from 'selectors/busy';
import { fspConfigValuesSelector } from 'selectors/fspConfigValues';
import { ReadOnlyFormControl } from 'components/common/fields';
import { useFSPConfig } from 'hooks';
import {
  getInitialValues,
  PZ_TIER_ONE_CLIENT_SUPPORT_NUMBER,
  PZ_TIER_ONE_PAYER_SUPPORT_NUMBER,
  PZ_TIER_ONE_SUPPORT_CONTACT_NAME,
  PZ_TIER_ONE_SUPPORT_CONTACT_PHONE,
} from './consts';

const useStyles = makeStyles(() => ({
  card: {
    maxWidth: 700,
    minWidth: 400,
  },
  content: {
    paddingTop: 0,
  },
}));

const TierOneSupportContent = ({ fspId }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const isBusy = useSelector((state) => isBusySelector(state, LOAD));
  const configValues = useSelector(fspConfigValuesSelector(fspId));
  const fspConfig = useFSPConfig(fspId, true);

  useEffect(() => {
    if (fspId) {
      dispatch(load({ fspId }));
    }
  }, [dispatch, fspId]);

  const values = getInitialValues(configValues);

  return (
    <Card classes={{ root: classes.card }} onClick={handleStopPropagation}>
      <CardHeader title="Contact Support" />
      <CardContent className={classes.content}>
        {isBusy ? (
          <ReadOnlyFormControl label="Loading..." />
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <ReadOnlyFormControl
                label={`${fspConfig?.fspName ?? ''} Support #`}
                value={values[PZ_TIER_ONE_SUPPORT_CONTACT_PHONE]}
              />
            </Grid>
            <Grid item xs={6}>
              <ReadOnlyFormControl
                helperText="M–F 8 am – 5 pm ET"
                label="Payer Support Number"
                value={values[PZ_TIER_ONE_PAYER_SUPPORT_NUMBER]}
              />
            </Grid>
            <Grid item xs={6}>
              <ReadOnlyFormControl
                label={`${fspConfig?.fspName ?? ''} Support Admin Contact`}
                value={values[PZ_TIER_ONE_SUPPORT_CONTACT_NAME]}
              />
            </Grid>
            <Grid item xs={6}>
              <ReadOnlyFormControl
                helperText="M–F 8 am – 5 pm ET"
                label="Client Support Number"
                value={values[PZ_TIER_ONE_CLIENT_SUPPORT_NUMBER]}
              />
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

TierOneSupportContent.propTypes = {
  fspId: PropTypes.number.isRequired,
};

export default TierOneSupportContent;
